import { COPY_POLICIES, DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
export const HERO_MAX_LENGTHS = {
    eyebrow: 20,
    heading: COPY_POLICIES.title.maxLength,
    subheading: COPY_POLICIES.description.maxLength,
};
export const heroSchema = {
    componentId: "Hero",
    scalarSlots: [
        {
            key: "eyebrow",
            label: "Eyebrow",
            type: "text",
            maxLength: HERO_MAX_LENGTHS.eyebrow,
        },
        {
            key: "heading",
            ...TITLE_COPY_LIMITS,
            label: "Heading",
            type: "text",
        },
        {
            key: "subheading",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Subheading",
            type: "textarea",
        },
    ],
    mediaSlots: [],
};
//# sourceMappingURL=hero.js.map